import { render, staticRenderFns } from "./CouponClientRegister.vue?vue&type=template&id=62771096"
import script from "./CouponClientRegister.vue?vue&type=script&lang=js"
export * from "./CouponClientRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports